
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("le4yZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $dh538 = parcelRequire("dh538");


var $9EFEY = parcelRequire("9EFEY");


var $6yuru = parcelRequire("6yuru");


var $f7lNm = parcelRequire("f7lNm");


var $9pwVP = parcelRequire("9pwVP");


var $bbPOv = parcelRequire("bbPOv");

var $850e39d8df191904$export$5fc610914b028d97 = /*#__PURE__*/ function(KnowledgeDiscoveryKeyPhraseInputTextFormat) {
    KnowledgeDiscoveryKeyPhraseInputTextFormat["PLAIN"] = "PLAIN";
    KnowledgeDiscoveryKeyPhraseInputTextFormat["ADF"] = "ADF";
    return KnowledgeDiscoveryKeyPhraseInputTextFormat;
}({});
var $850e39d8df191904$export$17a511c5c23509af = /*#__PURE__*/ function(KeyPhraseCategory) {
    KeyPhraseCategory["PROJECT"] = "PROJECT";
    KeyPhraseCategory["TEAM"] = "TEAM";
    KeyPhraseCategory["ACRONYM"] = "ACRONYM";
    KeyPhraseCategory["AUTO"] = "AUTO";
    KeyPhraseCategory["OTHER"] = "OTHER";
    return KeyPhraseCategory;
}({});
const $850e39d8df191904$export$276f56b9dab90860 = 'atlassian.knowledge-discovery.autohighlights';
const $850e39d8df191904$var$escapeRegExp = (regex)=>{
    return regex.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
};
const $850e39d8df191904$export$4a1c1074ca627 = (keyPhrases)=>{
    try {
        if (!keyPhrases.length) return new RegExp('(?!)');
        else return new RegExp(keyPhrases.map((node)=>`\\b${$850e39d8df191904$var$escapeRegExp(node.keyPhrase)}\\b`).join('|'), 'gi');
    } catch  {
        return new RegExp('(?!)');
    }
};
const $850e39d8df191904$var$getKeyphraseCategory = (keyPhrases)=>{
    return keyPhrases.length ? keyPhrases[0].category : "AUTO";
};
const $850e39d8df191904$var$initialState = {
    keyPhrases: [],
    keyPhraseCategory: "AUTO",
    autoHighlightRegex: new RegExp('(?!)'),
    loadAutohighlights: ()=>Promise.resolve([]),
    resetAutohighlights: ()=>{},
    autohighlightsLoading: false,
    error: undefined
};
const $850e39d8df191904$export$52e9ff9bfbb65046 = ({ entityAri: entityAri, workspaceId: workspaceId, product: product, productConfig: productConfig, fieldType: fieldType, cloudId: cloudId })=>{
    const [state, setState] = (0, $42omo.useState)($850e39d8df191904$var$initialState);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire((0, $f7lNm.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    const { jiraReporterAccountId: jiraReporterAccountId, jiraAssigneeAccountId: jiraAssigneeAccountId } = productConfig || {};
    const loadAutohighlights = (0, $42omo.useCallback)(async ({ inputText: inputText })=>{
        try {
            setState({
                ...$850e39d8df191904$var$initialState,
                autohighlightsLoading: true
            });
            const keyPhrasesResult = await (0, $9EFEY.fetchAggResponse)({
                graphQuery: (0, $bbPOv.KeyPhrasesQuery),
                variables: {
                    workspaceId: workspaceId,
                    entityAri: entityAri,
                    ...!!jiraReporterAccountId && {
                        jiraReporterAccountId: jiraReporterAccountId
                    },
                    ...!!jiraAssigneeAccountId && {
                        jiraAssigneeAccountId: jiraAssigneeAccountId
                    },
                    ...!!inputText && {
                        inputText: inputText
                    }
                },
                operationName: (0, $bbPOv.KEY_PHRASES_OPERATION_NAME),
                headers: (0, $6yuru.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: cloudId,
                    product: product
                })
            });
            const keyPhrases = keyPhrasesResult?.data?.knowledgeDiscovery?.keyPhrases?.nodes ? keyPhrasesResult.data.knowledgeDiscovery.keyPhrases.nodes : [];
            if (keyPhrases.length > 0 && (0, $dh538.fg)('kd_definitions_click_and_show_event_product_parity')) fireAnalyticsEvent((0, $9pwVP.onShownAutoDefinitionHighlights)({
                product: product,
                contentId: entityAri,
                keyPhrases: keyPhrases,
                fieldType: fieldType
            }));
            const autoHighlightRegex = $850e39d8df191904$export$4a1c1074ca627(keyPhrases);
            setState({
                ...$850e39d8df191904$var$initialState,
                keyPhraseCategory: $850e39d8df191904$var$getKeyphraseCategory(keyPhrases),
                autoHighlightRegex: autoHighlightRegex,
                keyPhrases: keyPhrases
            });
            return keyPhrases;
        } catch (error) {
            setState({
                ...$850e39d8df191904$var$initialState,
                error: error.message
            });
            return [];
        }
    }, [
        entityAri,
        workspaceId,
        fireAnalyticsEvent,
        product,
        jiraReporterAccountId,
        jiraAssigneeAccountId,
        fieldType,
        cloudId
    ]);
    const resetAutohighlights = (0, $42omo.useCallback)(()=>{
        setState($850e39d8df191904$var$initialState);
    }, []);
    const autoHighlightRegex = (0, $42omo.useMemo)(()=>state.autoHighlightRegex, [
        state.autoHighlightRegex
    ]);
    const autohighlightsLoading = (0, $42omo.useMemo)(()=>state.autohighlightsLoading, [
        state.autohighlightsLoading
    ]);
    const keyPhrases = (0, $42omo.useMemo)(()=>state.keyPhrases, [
        state.keyPhrases
    ]);
    const error = (0, $42omo.useMemo)(()=>state.error, [
        state.error
    ]);
    return {
        keyPhrases: keyPhrases,
        keyPhraseCategory: state.keyPhraseCategory,
        autoHighlightRegex: autoHighlightRegex,
        loadAutohighlights: loadAutohighlights,
        resetAutohighlights: resetAutohighlights,
        autohighlightsLoading: autohighlightsLoading,
        error: error
    };
};
module.exports["KnowledgeDiscoveryKeyPhraseInputTextFormat"] = $850e39d8df191904$export$5fc610914b028d97;
module.exports["KeyPhraseCategory"] = $850e39d8df191904$export$17a511c5c23509af;
module.exports["getHighlightRegex"] = $850e39d8df191904$export$4a1c1074ca627;
module.exports["useAutohighlightSupplier"] = $850e39d8df191904$export$52e9ff9bfbb65046;

});

parcelRegister("9EFEY", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $dwp40 = parcelRequire("dwp40");


var $i1ClO = parcelRequire("i1ClO");

const $f389ba2de7a9be34$var$DEFAULT_GRAPHQL_ENDPOINT = '/gateway/api/graphql';
async function $f389ba2de7a9be34$export$1642248503fca29({ graphQuery: graphQuery, variables: variables, operationName: operationName, aggAbsoluteUrl: url = $f389ba2de7a9be34$var$DEFAULT_GRAPHQL_ENDPOINT, cache: cache, headers: headers }) {
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers ? {
                    ...headers
                } : {}
            },
            body: JSON.stringify({
                operationName: operationName,
                query: graphQuery,
                variables: variables
            })
        },
        queryParams: {
            ...operationName && {
                q: operationName
            }
        }
    };
    // if there's a ttl use fetch with in-mem cacheing
    if (cache && (0, $dh538.fg)('kd_fe_enable_api_cache')) return (0, $i1ClO.fetchAggResponseWithCache)({
        graphQuery: graphQuery,
        variables: variables,
        operationName: operationName,
        cache: cache,
        headers: headers
    });
    return (0, $dwp40.utils).requestService({
        url: url
    }, options);
}
module.exports["fetchAggResponse"] = $f389ba2de7a9be34$export$1642248503fca29;

});

parcelRegister("i1ClO", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $iip0W = parcelRequire("iip0W");

const $d8368aeaca537ae2$var$DEFAULT_GRAPHQL_ENDPOINT = '/gateway/api/graphql';
async function $d8368aeaca537ae2$export$6fe550b7d5be614c({ graphQuery: graphQuery, variables: variables, operationName: operationName, aggAbsoluteUrl: url = $d8368aeaca537ae2$var$DEFAULT_GRAPHQL_ENDPOINT, cache: cache, headers: headers }) {
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers ? {
                    ...headers
                } : {}
            },
            body: JSON.stringify({
                operationName: operationName,
                query: graphQuery,
                variables: variables
            })
        },
        queryParams: {
            ...operationName && {
                q: operationName
            }
        }
    };
    let cachedResponse = (0, $iip0W.InMemCache).getData(cache.key);
    if (cachedResponse && (0, $iip0W.InMemCache).isValid(cache.key)) return Promise.resolve(cachedResponse);
    // return a pending promise that was cached earlier
    const inflightRequest = (0, $iip0W.InMemCache).getInflightRequest(cache.key);
    if (inflightRequest) return inflightRequest;
    // cache miss, fetch data from agg and store ref to promise
    const request = new Promise(async (resolve, reject)=>{
        try {
            const response = await (0, $dwp40.utils).requestService({
                url: url
            }, options);
            (0, $iip0W.InMemCache).setData({
                key: cache.key,
                response: response,
                ttl: cache.ttl
            });
            resolve(response);
        } catch (error) {
            reject(error);
        } finally{
            (0, $iip0W.InMemCache).removeInflightRequest(cache.key);
        }
    });
    (0, $iip0W.InMemCache).setInflightRequest({
        key: cache.key,
        request: request
    });
    return request;
}
module.exports["fetchAggResponseWithCache"] = $d8368aeaca537ae2$export$6fe550b7d5be614c;

});

parcelRegister("iip0W", function(module, exports) {
const $72ec73b0e41d4c0a$var$DEFAULT_TTL = 300000;
class $72ec73b0e41d4c0a$export$916bab80494ce385 {
    static setData({ key: key, response: response, ttl: ttl }) {
        this.cache.set(key, {
            ttl: Date.now() + (ttl || $72ec73b0e41d4c0a$var$DEFAULT_TTL),
            response: response
        });
    }
    static getData(key) {
        return this.cache.get(key)?.response;
    }
    static isValid(key) {
        const item = this.cache.get(key);
        return Boolean(item) && Date.now() < (item?.ttl || 0);
    }
    static getInflightRequest(key) {
        return this.inFlightRequests.get(key);
    }
    static setInflightRequest({ key: key, request: request }) {
        this.inFlightRequests.set(key, request);
    }
    static removeInflightRequest(key) {
        return this.inFlightRequests.delete(key);
    }
    // only for tests
    static clearCache() {
        this.cache.clear();
        this.inFlightRequests.clear();
    }
}
$72ec73b0e41d4c0a$export$916bab80494ce385.cache = new Map();
$72ec73b0e41d4c0a$export$916bab80494ce385.inFlightRequests = new Map();
module.exports["InMemCache"] = $72ec73b0e41d4c0a$export$916bab80494ce385;

});

parcelRegister("6yuru", function(module, exports) {

var $dh538 = parcelRequire("dh538");

function $9b992db01b095d2f$export$14ef296862e3705e({ atlWorkspaceId: atlWorkspaceId, tenantId: tenantId, product: product }) {
    if (!(0, $dh538.fg)('kd_agg_atl_attribution_header')) return;
    const atlAttributionHeader = {
        atlWorkspaceId: atlWorkspaceId,
        tenantId: tenantId,
        product: product
    };
    return {
        'atl-attribution': JSON.stringify(atlAttributionHeader)
    };
}
module.exports["createAtlAttributionHeader"] = $9b992db01b095d2f$export$14ef296862e3705e;

});

parcelRegister("9pwVP", function(module, exports) {

var $cqFuK = parcelRequire("cqFuK");


var $le4yZ = parcelRequire("le4yZ");


var $fjzE4 = parcelRequire("fjzE4");

const $135aee7ed4d7fef7$export$ae4ae603f16dcf42 = ({ commonAttributes: commonAttributes, newDefinition: newDefinition, restrictedScope: restrictedScope, sourceSelected: sourceSelected, aiDefinitionEdited: aiDefinitionEdited })=>{
    const { query: keyPhrase, answerString: oldDefinition, extraAttributes: extraAttributes, source: source } = commonAttributes;
    const { contentId: contentId, readingAidsSessionId: readingAidsSessionId } = extraAttributes || {};
    return {
        action: 'clicked',
        actionSubject: 'aiCuratedDefinitionUpdateButton',
        source: source,
        eventType: 'ui',
        attributes: {
            contentId: contentId,
            readingAidsSessionId: readingAidsSessionId,
            restrictedScope: restrictedScope,
            sourceSelected: sourceSelected,
            newDefinitionLength: newDefinition.length,
            aiDefinitionEdited: // whether the user is editing an AI answer or already edited definition
            aiDefinitionEdited
        },
        nonPrivacySafeAttributes: {
            keyPhrase: keyPhrase,
            oldDefinition: oldDefinition,
            newDefinition: newDefinition
        }
    };
};
const $135aee7ed4d7fef7$export$d80f83cdfda72179 = (props)=>{
    const { query: query, answerString: answerString, extraAttributes: extraAttributes, source: source } = props;
    const { contentId: contentId, readingAidsSessionId: readingAidsSessionId } = extraAttributes || {};
    return {
        action: 'clicked',
        actionSubject: 'aiCuratedDefinitionSeeEditHistoryButton',
        source: source,
        eventType: 'ui',
        attributes: {
            contentId: contentId,
            readingAidsSessionId: readingAidsSessionId
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $135aee7ed4d7fef7$export$5b155f527aff26b9 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerLikeButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $135aee7ed4d7fef7$export$c4c8b81ee90e6af2 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerDislikeButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
const $135aee7ed4d7fef7$export$42897f8f02baa658 = ({ product: product, contentId: contentId, keyPhrases: keyPhrases, fieldType: fieldType })=>({
        action: 'shown',
        actionSubject: 'aiDefinitionsAutohighlights',
        source: 'viewPageScreen',
        eventType: 'track',
        attributes: {
            product: product,
            contentId: contentId,
            numHighlights: keyPhrases.length,
            categories: (0, $fjzE4.getHighlightCategories)(keyPhrases),
            beAcronymsEnabled: true,
            fieldType: fieldType
        }
    });
const $135aee7ed4d7fef7$export$9e6261f08debf93b = ({ contentId: contentId, sessionId: sessionId, keyPhraseCategory: keyPhraseCategory, fieldType: fieldType })=>({
        action: 'clicked',
        actionSubject: 'aiDefinitionsAutohighlights',
        source: 'viewPageScreen',
        eventType: 'ui',
        attributes: {
            contentId: contentId,
            readingAidsSessionId: sessionId,
            keyPhraseCategory: keyPhraseCategory || (0, $le4yZ.KeyPhraseCategory).AUTO,
            fieldType: fieldType
        }
    });
const $135aee7ed4d7fef7$export$bfe6deae035e3ea7 = (props)=>({
        action: 'clicked',
        actionSubject: 'aiDefinitionsDisableDefinition',
        source: 'viewPageScreen',
        eventType: 'ui',
        attributes: {
            ...(0, $cqFuK.filterCommonAttributes)(props)
        }
    });
module.exports["onCuratedDefinitionUpdateButtonClicked"] = $135aee7ed4d7fef7$export$ae4ae603f16dcf42;
module.exports["onCuratedDefinitionSeeEditHistoryButtonClicked"] = $135aee7ed4d7fef7$export$d80f83cdfda72179;
module.exports["onLikeButtonClick"] = $135aee7ed4d7fef7$export$5b155f527aff26b9;
module.exports["onDislikeButtonClick"] = $135aee7ed4d7fef7$export$c4c8b81ee90e6af2;
module.exports["onShownAutoDefinitionHighlights"] = $135aee7ed4d7fef7$export$42897f8f02baa658;
module.exports["onClickAutoDefinitionHighlights"] = $135aee7ed4d7fef7$export$9e6261f08debf93b;
module.exports["onClickDisableDefinition"] = $135aee7ed4d7fef7$export$bfe6deae035e3ea7;

});

parcelRegister("fjzE4", function(module, exports) {

var $7azCD = parcelRequire("7azCD");

const $f09d80c8646d0453$export$e9131c78c1110376 = (str)=>(0, $7azCD.sha256)(str);
const $f09d80c8646d0453$export$72ebbc2f4d73897b = (sources)=>sources.map((source)=>({
            id: source.ari ?? source.id,
            type: source.type
        }));
const $f09d80c8646d0453$export$f600f3124ea5916b = (nodes)=>{
    const categories = new Map();
    try {
        nodes.forEach((node)=>{
            const curCategoryCount = categories.get(node.category);
            if (!!curCategoryCount) categories.set(node.category, curCategoryCount + 1);
            else categories.set(node.category, 1);
        });
    } catch  {
        return undefined;
    }
    return Object.fromEntries(categories);
};
module.exports["getHighlightCategories"] = $f09d80c8646d0453$export$f600f3124ea5916b;

});

parcelRegister("bbPOv", function(module, exports) {
const $b754f76c2ea6a90a$export$b260340f6ff10d53 = 'PlatformHighlightKeywordsQuery';
const $b754f76c2ea6a90a$export$39b2bc657daf065 = `
	query ${$b754f76c2ea6a90a$export$b260340f6ff10d53}(
		$entityAri: String!
		$workspaceId: String!
		$jiraReporterAccountId: String
		$jiraAssigneeAccountId: String
		$inputText: KnowledgeDiscoveryKeyPhraseInputText
	) {
		knowledgeDiscovery  {
			keyPhrases(entityAri: $entityAri, workspaceId: $workspaceId, jiraReporterAccountId: $jiraReporterAccountId, jiraAssigneeAccountId: $jiraAssigneeAccountId, inputText: $inputText) 
				@optIn(to: "KnowledgeDiscovery Get Key Phrases") {
				__typename
				... on KnowledgeDiscoveryKeyPhraseConnection {
					nodes {
						... on KnowledgeDiscoveryKeyPhrase {
							keyPhrase
							category
						}
					}
				}
				... on QueryError {
					message
				}
			}
		}
	}
`;
module.exports["KEY_PHRASES_OPERATION_NAME"] = $b754f76c2ea6a90a$export$b260340f6ff10d53;
module.exports["KeyPhrasesQuery"] = $b754f76c2ea6a90a$export$39b2bc657daf065;

});

parcelRegister("14FKK", function(module, exports) {
// create separate utils folder if need to export more utils
const $e67d683b71b74003$var$validMarks = (data)=>{
    const invalidMarks = [
        'annotation',
        'link'
    ];
    return !data.marks || !data.marks.some((mark)=>invalidMarks.includes(mark.type));
};
const $e67d683b71b74003$var$validType = (data)=>{
    const invalidTypes = [
        'codeBlock'
    ];
    return !invalidTypes.includes(data.type);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e67d683b71b74003$var$extractContent = (data, flatMap)=>{
    if ($e67d683b71b74003$var$validType(data)) {
        if (data.content && data.content.length > 0) for (const node of data.content)$e67d683b71b74003$var$extractContent(node, flatMap);
    }
    // leaf node
    if (data.type === 'text' && $e67d683b71b74003$var$validMarks(data)) flatMap.push(data);
};
const $e67d683b71b74003$export$4cf5403beffb0fc1 = (adfValue)=>{
    const flatMap = [];
    $e67d683b71b74003$var$extractContent(adfValue, flatMap);
    return flatMap.map((node)=>node.text).join(',');
};
module.exports["parseContent"] = $e67d683b71b74003$export$4cf5403beffb0fc1;

});

parcelRegister("eVM9z", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $eRXI0 = parcelRequire("eRXI0");


var $7Zbm6 = parcelRequire("7Zbm6");


var $9EFEY = parcelRequire("9EFEY");


var $6yuru = parcelRequire("6yuru");


var $5Ymlp = parcelRequire("5Ymlp");


var $xhg8G = parcelRequire("xhg8G");


var $9nZle = parcelRequire("9nZle");


var $4WiNS = parcelRequire("4WiNS");


var $3qbRZ = parcelRequire("3qbRZ");

const $e71f869528412a13$var$i18n = (0, $cgtv4.defineMessages)({
    searchAiDialogQueryPretext: {
        id: "contextual-reading-aids.search-ai-dialog.query-pretext",
        defaultMessage: "what is {queryText}?"
    }
});
const $e71f869528412a13$var$NO_CURATED_DEF_FOUND_MESSAGE = 'No matching scope for Definition';
const $e71f869528412a13$export$7111b45b195dd101 = ({ workspaceId: workspaceId, cloudIdARI: cloudIdARI, fetchConfig: fetchConfig, isDefinitionCurationEnabled: isDefinitionCurationEnabled, productConfig: productConfig, product: product })=>{
    const intl = (0, $8C5kA.default)();
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const { fireAnalyticsEvent: fireAnalyticsEvent, commonAttributes: commonAttributes } = (0, $eRXI0.useAIAnswerContext)();
    const { contentId: contentId } = productConfig;
    const fetchAIGeneratedDefinition = (0, $42omo.useCallback)(async ({ variables: variables })=>{
        const { query: query, locale: locale, additional_context: additional_context, experience: experience, followUpsEnabled: followUpsEnabled } = variables;
        if (contentId !== '') try {
            const precomputedResult = await (0, $9EFEY.fetchAggResponse)({
                graphQuery: (0, $4WiNS.PrecomputedDefinitionQuery),
                variables: {
                    workspaceId: workspaceId,
                    keyPhrase: variables.query,
                    contentId: contentId
                },
                headers: (0, $6yuru.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: cloudIdARI,
                    product: product
                })
            });
            if (precomputedResult.data && !precomputedResult.data.knowledgeDiscovery.autoDefinition.message) {
                const data = {
                    nlpSearch: (0, $3qbRZ.mapCustomDefinitionToNLPSearchType)(precomputedResult.data.knowledgeDiscovery.autoDefinition)
                };
                setLoading(false);
                return data;
            } else if (precomputedResult.data && precomputedResult.data.knowledgeDiscovery.autoDefinition.message) throw new Error(precomputedResult.data.knowledgeDiscovery.autoDefinition.message);
            else throw new Error('Something went wrong with fetching precomputed definition');
        } catch (error) {
            if (error instanceof Object && 'message' in error && error.message !== $e71f869528412a13$var$NO_CURATED_DEF_FOUND_MESSAGE) fireAnalyticsEvent((0, $xhg8G.fetchPrecomputedDefinitionErrorPayload)(error, commonAttributes));
        }
        const streamFetchArgs = {
            variables: {
                query: intl.formatMessage($e71f869528412a13$var$i18n.searchAiDialogQueryPretext, {
                    queryText: query
                }),
                locale: locale,
                cloudIdARI: cloudIdARI,
                additional_context: additional_context,
                experience: experience,
                followUpsEnabled: followUpsEnabled
            },
            isReadingAids: true,
            fetchConfig: fetchConfig,
            generatorConfig: {
                yieldAnswerPart: true,
                yieldFinalResponse: true
            },
            onStreamFinalResponse: ()=>{
                setLoading(false);
            }
        };
        return {
            type: (0, $7Zbm6.AIAnswerAPIType).STREAM,
            stream: (0, $5Ymlp.aiDefinitionsStreamFetchConvoAIService)(streamFetchArgs)
        };
    }, [
        cloudIdARI,
        fetchConfig,
        intl,
        commonAttributes,
        fireAnalyticsEvent,
        workspaceId,
        contentId,
        product
    ]);
    const fetchDefinition = (0, $42omo.useCallback)(async ({ variables: variables })=>{
        if (isDefinitionCurationEnabled) try {
            let confluenceScopeId, jiraScopeId;
            if ('spaceId' in productConfig) confluenceScopeId = productConfig;
            else if ('projectId' in productConfig) jiraScopeId = {
                projectId: productConfig.projectId
            };
            const result = await (0, $9EFEY.fetchAggResponse)({
                graphQuery: (0, $9nZle.CuratedDefinitionQuery),
                variables: {
                    workspaceId: workspaceId,
                    keyPhrase: variables.query,
                    confluenceScopeId: confluenceScopeId,
                    jiraScopeId: jiraScopeId
                },
                operationName: (0, $9nZle.CURATED_DEFINITION_OPERATION_NAME),
                headers: (0, $6yuru.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: cloudIdARI,
                    product: product
                })
            });
            if (result.data && !result.data.knowledgeDiscovery.definition.message) {
                const data = {
                    nlpSearch: (0, $3qbRZ.mapCustomDefinitionToNLPSearchType)(result.data.knowledgeDiscovery.definition)
                };
                setLoading(false);
                return data;
            } else if (result.data && result.data.knowledgeDiscovery.definition.message) throw new Error(result.data.knowledgeDiscovery.definition.message);
            else throw new Error('Something went wrong with fetching curated definition');
        } catch (error) {
            // want to fire event when error.message does not equal the no curated definition message
            // returned by the query in data.knowledgeDiscovery.definition.message
            if (error instanceof Object && 'message' in error && error.message !== $e71f869528412a13$var$NO_CURATED_DEF_FOUND_MESSAGE) fireAnalyticsEvent((0, $xhg8G.fetchCuratedDefinitionErrorPayload)(error, commonAttributes));
            return fetchAIGeneratedDefinition({
                variables: variables
            });
        }
        return fetchAIGeneratedDefinition({
            variables: variables
        });
    }, [
        productConfig,
        fetchAIGeneratedDefinition,
        isDefinitionCurationEnabled,
        workspaceId,
        commonAttributes,
        fireAnalyticsEvent,
        cloudIdARI,
        product
    ]);
    return {
        fetchDefinition: fetchDefinition,
        loading: loading
    };
};
module.exports["useDefinitionSupplier"] = $e71f869528412a13$export$7111b45b195dd101;

});

parcelRegister("5Ymlp", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $epS7s = parcelRequire("epS7s");


var $iA4lt = parcelRequire("iA4lt");


var $7Zbm6 = parcelRequire("7Zbm6");


var $4Zqgi = parcelRequire("4Zqgi");


var $f7lNm = parcelRequire("f7lNm");


var $2NVuz = parcelRequire("2NVuz");


var $5Wlau = parcelRequire("5Wlau");

const $6ff046935ab0156c$var$identityUserCloudARIPrefix = 'ari:cloud:identity::user/';
function $6ff046935ab0156c$var$getAgentAndExperience(isReadingAids) {
    return isReadingAids ? {
        named_id: 'reading_aids_agent',
        experience: 'reading-aids'
    } : {
        named_id: 'sain_agent',
        experience: 'sain'
    };
}
function $6ff046935ab0156c$var$mapMimeTypeToFormat(mimeType) {
    switch(mimeType){
        case 'text/markdown':
            return (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN;
        case 'text/adf':
            return (0, $7Zbm6.NLPSearchResultFormat).ADF;
        case 'text/json':
            return (0, $7Zbm6.NLPSearchResultFormat).JSON;
        default:
            return (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN;
    }
}
function $6ff046935ab0156c$var$mapErrorToSain(error, traceId) {
    const errorMessage = 'message_template' in error ? error.message_template : error.message.message_template;
    switch(errorMessage){
        case 'NO_ANSWER_LLM':
            return (0, $7Zbm6.NLPSearchErrorState).NoAnswer;
        case 'NO_ANSWER_PEOPLE':
            return (0, $7Zbm6.NLPSearchErrorState).NoAnswerWhoQuestion;
        case 'NO_ANSWER_KEYWORDS':
            return (0, $7Zbm6.NLPSearchErrorState).NoAnswerKeywords;
        case 'NO_ANSWER_SEARCH_QA_PLUGIN':
            return (0, $7Zbm6.NLPSearchErrorState).NoAnswerSearchResults;
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return (0, $7Zbm6.NLPSearchErrorState).AcceptableUseViolation;
        case 'OPENAI_RATE_LIMIT_USER_ABUSE':
            return (0, $7Zbm6.NLPSearchErrorState).NoAnswerOpenAIRateLimitUserAbuse;
        case 'FEATURE_DISABLED_ON_SITE':
            return (0, $7Zbm6.NLPSearchErrorState).AIDisabled;
        default:
            (0, $4Zqgi.logger).error({
                error: error,
                functionName: 'mapErrorToSain: NetworkError',
                traceId: traceId
            });
            return (0, $7Zbm6.NLPSearchErrorState).NetworkError;
    }
}
function $6ff046935ab0156c$var$mapMessageToNLPSearchType(message, requestId) {
    // Handle cases where message is directly in root or nested under message.message
    const messageContent = message.message || message;
    return {
        nlpResult: messageContent.content,
        uniqueSources: message.sources ? message.sources.map((source)=>({
                ari: source.ari,
                id: source.id?.toString(),
                title: source.title,
                product: source.product,
                type: source.type,
                url: source.url,
                lastModified: source.lastModified,
                iconUrl: null,
                spaceName: null,
                spaceUrl: null
            })) : [],
        disclaimer: messageContent.message_metadata?.disclaimer ?? null,
        errorState: null,
        format: $6ff046935ab0156c$var$mapMimeTypeToFormat(messageContent.content_mime_type),
        extraAPIAnalyticsAttributes: {
            message_id: messageContent.id,
            conversational_channel_id: messageContent.conversation_channel_id,
            experience_id: messageContent.experience_id,
            user_id: messageContent.user_ari?.replace($6ff046935ab0156c$var$identityUserCloudARIPrefix, '') ?? null,
            userQuery: message.human_message?.content ?? null,
            requestId: (0, $dh538.fg)('kd_fix_sain_mau_instrumentation') ? requestId ?? null : message.message?.message_metadata?.request_id ?? null,
            answerGenerationModel: message.usage_data ?? null,
            sources: message.sources,
            cacheInfo: message.message?.message_metadata?.global_cache_info ?? null,
            pluginInvocations: message.message?.plugin_invocations,
            rawJson: message,
            ...(0, $dh538.fg)('kd_sain_online_debugger') && {
                minion_outputs: message.message?.minion_outputs,
                traceId: requestId ?? null
            }
        }
    };
}
function $6ff046935ab0156c$var$mapStreamResponse(response, traceId) {
    if ((0, $2NVuz.isStreamError)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse,
        message: {
            errorState: $6ff046935ab0156c$var$mapErrorToSain(response, traceId),
            errorCode: response.message.status_code,
            disclaimer: null,
            format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN,
            uniqueSources: []
        }
    };
    if ((0, $2NVuz.isStreamGenerationType)(response) && (0, $dh538.fg)('kd_dynamic_layout_in_sain')) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).GenerationType,
        message: {
            answer_generation_type: response.message.answer_generation_type
        }
    };
    if ((0, $2NVuz.isStreamTrace)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).Trace,
        message: response.message.content
    };
    if ((0, $2NVuz.isStreamAnswerPart)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).AnswerPart,
        message: {
            nlpResult: response.message.content
        }
    };
    if ((0, $2NVuz.isStreamResponse)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse,
        message: $6ff046935ab0156c$var$mapMessageToNLPSearchType(response.message, traceId)
    };
    if ((0, $2NVuz.isStreamFollowUp)(response)) return {
        type: 'follow-up',
        queries: response.message.follow_up_queries ?? []
    };
    if ((0, $2NVuz.isStreamErrorStateQuerySuggestions)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).ErrorStateQuerySuggestions,
        suggested_queries: response.message.suggested_queries ?? []
    };
    if ((0, $dh538.fg)('kd_dynamic_layout_in_sain')) {
        if ((0, $2NVuz.isStreamDynamicLayoutSubAgent)(response)) return {
            type: (0, $7Zbm6.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage,
            message: response.message
        };
    }
    if ((0, $dh538.fg)('kd_sain_early_stop_hello_exp_fg') || (0, $dh538.fg)('kd_sain_early_stop_customer_exp_fg')) {
        if ((0, $2NVuz.isStreamEarlyStop)(response)) {
            const earlyStopSearchResult = {
                nlpResult: response.message?.reason ?? '',
                format: null,
                uniqueSources: [],
                errorState: (0, $7Zbm6.NLPSearchErrorState).EarlyStop,
                disclaimer: null
            };
            return {
                type: (0, $7Zbm6.AIAnswerQueryStreamType).EarlyStop,
                message: earlyStopSearchResult
            };
        }
    }
    return {
        // Don't currently handle other types, such as PLUGIN_INVOCATION
        type: 'other'
    };
}
async function* $6ff046935ab0156c$export$87d234127b4babfd({ fetchReturn: fetchReturn, variables: variables, fetchConfig: fetchConfig }) {
    try {
        const { query: query, locale: locale, experience: experience, filters: filters, cloudIdARI: cloudIdARI, followUpsEnabled: followUpsEnabled } = variables || {};
        const url = `${fetchConfig?.hostName || ''}${(0, $f7lNm.SAIN_STREAMING_API)}`;
        const response = await (fetchReturn ? fetchReturn : fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: query,
                filters: filters,
                locations: [
                    cloudIdARI
                ],
                locale: locale,
                experience: experience,
                followUpsEnabled: followUpsEnabled
            }),
            credentials: fetchConfig?.credentials || 'same-origin'
        }));
        if (!response.ok) // For non 200 status codes
        return {
            state: 'failed',
            reason: 'backend',
            details: 'Unhandled error response received',
            errorCode: response.status
        };
        if (!response.body) return {
            state: 'failed',
            reason: 'backend',
            details: 'response.body missing',
            errorCode: response.status
        };
        try {
            const reader = response.body.getReader();
            const decoder = new TextDecoder('utf-8');
            let buffer = '';
            let done = false;
            let finalResponse;
            while(!done){
                const { value: value, done: doneReading } = await reader.read();
                done = doneReading;
                const chunkValue = decoder.decode(value);
                buffer = buffer + chunkValue;
                // Split the buffer by line breaks
                const lines = buffer.split('\n');
                // Process all complete lines, except for the last one (which might be incomplete)
                while(lines.length > 1){
                    const line = lines.shift();
                    const parsedData = JSON.parse(line);
                    if (parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerType || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerPart || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).GenerationType || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).Trace || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).ErrorStateQuerySuggestions || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage) yield parsedData;
                    else {
                        finalResponse = parsedData;
                        done = true;
                    }
                }
                // Keep the last (potentially incomplete) line in the buffer
                buffer = lines[0];
            }
            if (finalResponse?.type !== (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse) return {
                state: 'failed',
                reason: 'parsing',
                error: 'Unexpected final response value'
            };
            return {
                state: 'complete',
                value: finalResponse
            };
        } catch (parsingError) {
            return {
                state: 'failed',
                reason: 'parsing',
                error: parsingError
            };
        }
    } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') // this is likely an abort error
        return {
            state: 'failed',
            reason: 'aborted'
        };
        if (error instanceof Error) return {
            state: 'failed',
            reason: 'error',
            details: error.message,
            error: error
        };
        return {
            state: 'failed',
            reason: 'unknown'
        };
    }
}
const $6ff046935ab0156c$var$getAgentInput = ({ variables: variables, fetchConfig: fetchConfig })=>{
    const { query: query, locale: locale, additional_context: additional_context, experimentContext: experimentContext, isQuerySuggestion: isQuerySuggestion } = variables || {};
    return {
        content: query,
        locale: locale,
        additional_context: additional_context,
        entity_ari: fetchConfig?.entity_ari,
        ...experimentContext && (0, $dh538.fg)('kd_sain_backend_exp_context') && {
            experimentContext: experimentContext
        },
        ...typeof isQuerySuggestion === 'boolean' && (0, $dh538.fg)('kd_zero_query_suggestions_v1_hello_gate') ? {
            isQuerySuggestion: isQuerySuggestion
        } : {}
    };
};
const $6ff046935ab0156c$var$getPromptOverrideContext = ()=>{
    if (!(0, $dh538.fg)('convo_ai_sain_enable_prompt_override_hello_only')) return {};
    const promptOverride = (0, $epS7s.getSessionItem)((0, $f7lNm.PROMPT_OVERRIDE_SESSION_KEY));
    if (!promptOverride) return {};
    return {
        aiFeatureContext: {
            systemPromptOverride: promptOverride
        }
    };
};
async function* $6ff046935ab0156c$export$ba95d3529d42f9ef({ fetchReturn: fetchReturn, variables: variables, isReadingAids: isReadingAids, fetchConfig: fetchConfig, generatorConfig: generatorConfig = {
    yieldAnswerPart: true,
    yieldFinalResponse: false
}, onStreamFinalResponse: onStreamFinalResponse }) {
    try {
        const { filters: filters, selectedProduct: selectedProduct } = variables || {};
        const { experience: experience, named_id: named_id } = $6ff046935ab0156c$var$getAgentAndExperience(isReadingAids);
        const url = `${fetchConfig?.hostName || ''}${(0, $f7lNm.ASSISTANCE_SERVICE_API_BASE_URL)}/chat/v1/invoke_agent/stream`;
        const streamFilters = filters && !Array.isArray(filters) && (0, $dh538.fg)('kd_add_common_filters_support_to_sain') ? [
            {
                commonFilters: filters.commonFilters
            },
            {
                confluenceFilters: filters.confluenceFilters
            }
        ] : [
            {
                confluenceFilters: filters
            }
        ];
        if (selectedProduct) streamFilters.push({
            knowledgeSources: [
                selectedProduct
            ]
        });
        const response = await (fetchReturn ? fetchReturn : fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Product': 'confluence',
                'X-Experience-Id': experience,
                ...fetchConfig?.headers ? fetchConfig.headers : {}
            },
            body: JSON.stringify({
                recipient_agent_named_id: named_id,
                agent_input: {
                    ...$6ff046935ab0156c$var$getAgentInput({
                        variables: variables,
                        fetchConfig: fetchConfig
                    }),
                    filters: filters ? streamFilters : undefined
                }
            }),
            credentials: fetchConfig?.credentials || 'same-origin',
            signal: fetchConfig?.timeout ? AbortSignal.timeout(fetchConfig?.timeout) : undefined
        }));
        const traceId = response.headers.get('x-trace-id') || null;
        if (!response.body) return {
            state: 'failed',
            reason: 'backend',
            details: 'response.body missing',
            errorCode: response.status
        };
        try {
            const reader = response.body.getReader();
            const decoder = new TextDecoder('utf-8');
            let buffer = '';
            let done = false;
            let finalResponse;
            yield {
                type: (0, $7Zbm6.AIAnswerQueryStreamType).AnswerType,
                message: {
                    format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN
                }
            };
            while(!done){
                const { value: value, done: doneReading } = await reader.read();
                done = doneReading;
                const chunkValue = decoder.decode(value);
                buffer = buffer + chunkValue;
                // Split the buffer by line breaks
                const lines = buffer.split('\n');
                // add case here to return error from stream
                if (!response.ok) {
                    const finalResponse = JSON.parse(lines[0]);
                    if (finalResponse?.errors.includes((0, $7Zbm6.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR)) return {
                        state: 'failed',
                        reason: 'backend',
                        details: (0, $7Zbm6.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR,
                        errorCode: response.status
                    };
                    // For non 200 status codes
                    return {
                        state: 'failed',
                        reason: 'backend',
                        details: 'Unhandled error response received',
                        errorCode: response.status
                    };
                }
                // Process all complete lines, except for the last one (which might be incomplete)
                while(lines.length > 1){
                    const line = lines.shift();
                    const parsedData = (0, $dh538.fg)('kd_separate_sain_definitions_response_mappers') ? (0, $5Wlau.mapStreamSAINResponse)(JSON.parse(line), traceId) : $6ff046935ab0156c$var$mapStreamResponse(JSON.parse(line), traceId);
                    if (parsedData.type === 'other') continue;
                    else if (parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerType || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerPart || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).GenerationType || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).Trace || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).ErrorStateQuerySuggestions || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage) {
                        if (generatorConfig.yieldAnswerPart) yield parsedData;
                    } else if (parsedData.type === 'follow-up') {
                        if (!finalResponse?.message || !variables?.followUpsEnabled) continue;
                        finalResponse.message.nlpFollowUpResults = {
                            followUps: parsedData.queries
                        };
                        done = true;
                    } else if (parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).EarlyStop) return {
                        state: 'complete',
                        value: parsedData
                    };
                    else {
                        finalResponse = parsedData;
                        onStreamFinalResponse?.();
                        if (!variables?.followUpsEnabled) done = true;
                        if (generatorConfig.yieldFinalResponse) yield finalResponse;
                    }
                }
                // Keep the last (potentially incomplete) line in the buffer
                buffer = lines[0];
            }
            if (finalResponse?.type !== (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse) return {
                state: 'failed',
                reason: 'parsing',
                error: 'Unexpected final response value'
            };
            return {
                state: 'complete',
                value: finalResponse
            };
        } catch (parsingError) {
            return {
                state: 'failed',
                reason: 'parsing',
                error: parsingError
            };
        }
    } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') // this is likely an abort error
        return {
            state: 'failed',
            reason: 'aborted'
        };
        if (error instanceof DOMException && error.name === 'TimeoutError') return {
            state: 'failed',
            reason: 'timeout'
        };
        if (error instanceof Error) return {
            state: 'failed',
            reason: 'error',
            details: error.message,
            error: error
        };
        return {
            state: 'failed',
            reason: 'unknown'
        };
    }
}
async function* $6ff046935ab0156c$export$3e1bd964ad0ba888({ fetchReturn: fetchReturn, variables: variables, isReadingAids: isReadingAids, fetchConfig: fetchConfig, generatorConfig: generatorConfig = {
    yieldAnswerPart: true,
    yieldFinalResponse: false
}, onStreamFinalResponse: onStreamFinalResponse }) {
    try {
        const { filters: filters, selectedProduct: selectedProduct } = variables || {};
        const { experience: experience, named_id: named_id } = $6ff046935ab0156c$var$getAgentAndExperience(isReadingAids);
        const url = `${fetchConfig?.hostName || ''}${(0, $f7lNm.ASSISTANCE_SERVICE_API_BASE_URL)}/rovo/v1/sain/stream`;
        const streamFilters = filters && !Array.isArray(filters) && (0, $dh538.fg)('kd_add_common_filters_support_to_sain') ? [
            {
                commonFilters: filters.commonFilters
            },
            {
                confluenceFilters: filters.confluenceFilters
            }
        ] : [
            {
                confluenceFilters: filters
            }
        ];
        if (selectedProduct) streamFilters.push({
            knowledgeSources: [
                selectedProduct
            ]
        });
        const response = await (fetchReturn ? fetchReturn : fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Product': 'confluence',
                'X-Experience-Id': experience,
                ...fetchConfig?.headers ? fetchConfig.headers : {}
            },
            body: JSON.stringify({
                recipient_agent_named_id: named_id,
                agent_input: {
                    ...$6ff046935ab0156c$var$getAgentInput({
                        variables: variables,
                        fetchConfig: fetchConfig
                    }),
                    filters: filters ? streamFilters : undefined,
                    ...$6ff046935ab0156c$var$getPromptOverrideContext()
                }
            }),
            credentials: fetchConfig?.credentials || 'same-origin',
            signal: fetchConfig?.timeout ? AbortSignal.timeout(fetchConfig?.timeout) : undefined
        }));
        const traceId = response.headers.get('x-trace-id') || null;
        if (!response.body) return {
            state: 'failed',
            reason: 'backend',
            details: 'response.body missing',
            errorCode: response.status
        };
        try {
            const reader = response.body.getReader();
            const decoder = new TextDecoder('utf-8');
            let buffer = '';
            let done = false;
            let finalResponse;
            yield {
                type: (0, $7Zbm6.AIAnswerQueryStreamType).AnswerType,
                message: {
                    format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN
                }
            };
            while(!done){
                const { value: value, done: doneReading } = await reader.read();
                done = doneReading;
                const chunkValue = decoder.decode(value);
                buffer = buffer + chunkValue;
                // Split the buffer by line breaks
                const lines = buffer.split('\n');
                // add case here to return error from stream
                if (!response.ok) {
                    const finalResponse = JSON.parse(lines[0]);
                    if (finalResponse?.errors.includes((0, $7Zbm6.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR)) return {
                        state: 'failed',
                        reason: 'backend',
                        details: (0, $7Zbm6.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR,
                        errorCode: response.status
                    };
                    // For non 200 status codes
                    return {
                        state: 'failed',
                        reason: 'backend',
                        details: 'Unhandled error response received',
                        errorCode: response.status
                    };
                }
                // Process all complete lines, except for the last one (which might be incomplete)
                while(lines.length > 1){
                    const line = lines.shift();
                    const parsedData = (0, $dh538.fg)('kd_separate_sain_definitions_response_mappers') ? (0, $5Wlau.mapStreamSAINResponse)(JSON.parse(line), traceId) : $6ff046935ab0156c$var$mapStreamResponse(JSON.parse(line), traceId);
                    if (parsedData.type === 'other') continue;
                    else if (parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerType || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerPart || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).GenerationType || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).Trace || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage) {
                        if (generatorConfig.yieldAnswerPart) yield parsedData;
                    } else if (parsedData.type === 'follow-up') {
                        if (!finalResponse?.message || !variables?.followUpsEnabled) continue;
                        finalResponse.message.nlpFollowUpResults = {
                            followUps: parsedData.queries
                        };
                        const { serveExperiment: serveErrorStateSuggestedQueriesExp } = (0, $iA4lt.getFrontendExperiment)({
                            abTestId: 'kd_sain_show_no_answer_suggestions_exp'
                        });
                        if (!serveErrorStateSuggestedQueriesExp) done = true;
                    } else if (parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).ErrorStateQuerySuggestions) {
                        if (!finalResponse?.message) continue;
                        finalResponse.message.nlpSuggestedQueries = parsedData.suggested_queries;
                        done = true;
                    } else if (parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).EarlyStop) return {
                        state: 'complete',
                        value: parsedData
                    };
                    else {
                        finalResponse = parsedData;
                        onStreamFinalResponse?.();
                        if (!variables?.followUpsEnabled) done = true;
                        if (generatorConfig.yieldFinalResponse) yield finalResponse;
                    }
                }
                // Keep the last (potentially incomplete) line in the buffer
                buffer = lines[0];
            }
            if (finalResponse?.type !== (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse) return {
                state: 'failed',
                reason: 'parsing',
                error: 'Unexpected final response value'
            };
            return {
                state: 'complete',
                value: finalResponse
            };
        } catch (parsingError) {
            return {
                state: 'failed',
                reason: 'parsing',
                error: parsingError
            };
        }
    } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') // this is likely an abort error
        return {
            state: 'failed',
            reason: 'aborted'
        };
        if (error instanceof DOMException && error.name === 'TimeoutError') return {
            state: 'failed',
            reason: 'timeout'
        };
        if (error instanceof Error) return {
            state: 'failed',
            reason: 'error',
            details: error.message,
            error: error
        };
        return {
            state: 'failed',
            reason: 'unknown'
        };
    }
}
async function $6ff046935ab0156c$export$c8ae4e2310d6c222({ variables: variables, isReadingAids: isReadingAids, fetchConfig: fetchConfig }) {
    const { experience: experience, named_id: named_id } = $6ff046935ab0156c$var$getAgentAndExperience(isReadingAids);
    const url = `${fetchConfig?.hostName || ''}${(0, $f7lNm.ASSISTANCE_SERVICE_API_BASE_URL)}/chat/v1/invoke_agent`;
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Product': 'confluence',
            'X-Experience-Id': experience,
            ...fetchConfig?.headers
        },
        body: JSON.stringify({
            recipient_agent_named_id: named_id,
            agent_input: $6ff046935ab0156c$var$getAgentInput({
                variables: variables,
                fetchConfig: fetchConfig
            })
        }),
        credentials: fetchConfig?.credentials || 'same-origin',
        signal: fetchConfig?.timeout ? AbortSignal.timeout(fetchConfig?.timeout) : undefined
    });
    const traceId = response.headers.get('x-trace-id') || null;
    const data = await response.json();
    if ('message_template' in data) return {
        nlpSearch: {
            errorState: $6ff046935ab0156c$var$mapErrorToSain(data, traceId),
            disclaimer: null,
            format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN,
            uniqueSources: []
        }
    };
    return {
        nlpSearch: $6ff046935ab0156c$var$mapMessageToNLPSearchType(data, traceId)
    };
}
async function* $6ff046935ab0156c$export$824b789d24de77d3({ fetchReturn: fetchReturn, variables: variables, fetchConfig: fetchConfig, generatorConfig: generatorConfig = {
    yieldAnswerPart: true,
    yieldFinalResponse: false
}, onStreamFinalResponse: onStreamFinalResponse }) {
    try {
        const url = `${fetchConfig?.hostName || ''}${(0, $f7lNm.ASSISTANCE_SERVICE_API_BASE_URL)}/rovo/v1/ai-definition`;
        const response = await (fetchReturn ? fetchReturn : fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Product': 'confluence',
                'X-Experience-Id': 'reading-aids',
                ...fetchConfig?.headers ? fetchConfig.headers : {}
            },
            body: JSON.stringify({
                ...$6ff046935ab0156c$var$getAgentInput({
                    variables: variables,
                    fetchConfig: fetchConfig
                })
            }),
            credentials: fetchConfig?.credentials || 'same-origin',
            signal: fetchConfig?.timeout ? AbortSignal.timeout(fetchConfig?.timeout) : undefined
        }));
        const traceId = response.headers.get('x-trace-id') || null;
        if (!response.body) return {
            state: 'failed',
            reason: 'backend',
            details: 'response.body missing',
            errorCode: response.status
        };
        try {
            const reader = response.body.getReader();
            const decoder = new TextDecoder('utf-8');
            let buffer = '';
            let done = false;
            let finalResponse;
            yield {
                type: (0, $7Zbm6.AIAnswerQueryStreamType).AnswerType,
                message: {
                    format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN
                }
            };
            while(!done){
                const { value: value, done: doneReading } = await reader.read();
                done = doneReading;
                const chunkValue = decoder.decode(value);
                buffer = buffer + chunkValue;
                // Split the buffer by line breaks
                const lines = buffer.split('\n');
                // add case here to return error from stream
                if (!response.ok) {
                    const finalResponse = JSON.parse(lines[0]);
                    if (finalResponse?.errors.includes((0, $7Zbm6.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR)) return {
                        state: 'failed',
                        reason: 'backend',
                        details: (0, $7Zbm6.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR,
                        errorCode: response.status
                    };
                    return {
                        state: 'failed',
                        reason: 'backend',
                        details: 'Unhandled error response received',
                        errorCode: response.status
                    };
                }
                // Process all complete lines, except for the last one (which might be incomplete)
                while(lines.length > 1){
                    const line = lines.shift();
                    const parsedData = (0, $dh538.fg)('kd_separate_sain_definitions_response_mappers') ? (0, $5Wlau.mapStreamDefinitionResponse)(JSON.parse(line)) : $6ff046935ab0156c$var$mapStreamResponse(JSON.parse(line), traceId);
                    if (parsedData.type === 'other') continue;
                    else if (parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerType || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).AnswerPart || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).GenerationType || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).Trace || parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage) {
                        if (generatorConfig.yieldAnswerPart) yield parsedData;
                    } else if (parsedData.type === 'follow-up') {
                        if (!finalResponse?.message || !variables?.followUpsEnabled) continue;
                        finalResponse.message.nlpFollowUpResults = {
                            followUps: parsedData.queries
                        };
                        const { serveExperiment: serveErrorStateSuggestedQueriesExp } = (0, $iA4lt.getFrontendExperiment)({
                            abTestId: 'kd_sain_show_no_answer_suggestions_exp'
                        });
                        if (!serveErrorStateSuggestedQueriesExp) done = true;
                    } else if (parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).ErrorStateQuerySuggestions) {
                        if (!finalResponse?.message) continue;
                        finalResponse.message.nlpSuggestedQueries = parsedData.suggested_queries;
                        done = true;
                    } else if (parsedData.type === (0, $7Zbm6.AIAnswerQueryStreamType).EarlyStop) return {
                        state: 'complete',
                        value: parsedData
                    };
                    else {
                        finalResponse = parsedData;
                        onStreamFinalResponse?.();
                        if (!variables?.followUpsEnabled) done = true;
                        if (generatorConfig.yieldFinalResponse) yield finalResponse;
                    }
                }
                // Keep the last (potentially incomplete) line in the buffer
                buffer = lines[0];
            }
            if (finalResponse?.type !== (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse) return {
                state: 'failed',
                reason: 'parsing',
                error: 'Unexpected final response value'
            };
            return {
                state: 'complete',
                value: finalResponse
            };
        } catch (parsingError) {
            return {
                state: 'failed',
                reason: 'parsing',
                error: parsingError
            };
        }
    } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') return {
            state: 'failed',
            reason: 'aborted'
        };
        if (error instanceof DOMException && error.name === 'TimeoutError') return {
            state: 'failed',
            reason: 'timeout'
        };
        if (error instanceof Error) return {
            state: 'failed',
            reason: 'error',
            details: error.message,
            error: error
        };
        return {
            state: 'failed',
            reason: 'unknown'
        };
    }
}
module.exports["sainStreamFetchConvoAIService"] = $6ff046935ab0156c$export$3e1bd964ad0ba888;
module.exports["aiDefinitionsStreamFetchConvoAIService"] = $6ff046935ab0156c$export$824b789d24de77d3;

});

parcelRegister("iA4lt", function(module, exports) {

var $c6GJD = parcelRequire("c6GJD");


var $4vEoF = parcelRequire("4vEoF");

const $3a954310db248169$export$a68238496eb1c8ce = ({ abTestId: abTestId, onError: onError })=>{
    try {
        const cohort = (0, $c6GJD.default).getExperiment(abTestId).get('cohort', (0, $4vEoF.Cohort).Default);
        const serveExperiment = cohort === (0, $4vEoF.Cohort).Test;
        return {
            serveExperiment: serveExperiment,
            abTestId: abTestId,
            cohort: cohort
        };
    } catch (error) {
        onError?.(error);
    }
    return {
        serveExperiment: false,
        abTestId: abTestId,
        cohort: (0, $4vEoF.Cohort).Default
    };
};
const $3a954310db248169$export$8774a01dc80b4a26 = (overrides)=>{
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    if ((0, $c6GJD.default).checkGate('search-experiment-overrides-killswitch')) return $3a954310db248169$var$defaultCheckGate;
    if (!overrides) return $3a954310db248169$var$defaultCheckGate;
    try {
        const gates = overrides.filter((overrides)=>overrides.type === 'gate');
        const getFeatureGate = (name)=>{
            const overrideFeatureGate = gates.find((override)=>'name' in override && override.name === name);
            if (!overrideFeatureGate) return $3a954310db248169$var$defaultCheckGate(name);
            // Overrides always resolve to true as using an override is equivelant to turning FF on.
            return true;
        };
        return getFeatureGate;
    } catch (e) {
        console.error(e);
        return $3a954310db248169$var$defaultCheckGate;
    }
};
const $3a954310db248169$export$841981a8a1feee8d = (overrides)=>{
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    if ((0, $c6GJD.default).checkGate('search-experiment-overrides-killswitch')) return $3a954310db248169$export$a68238496eb1c8ce;
    if (!overrides) return $3a954310db248169$export$a68238496eb1c8ce;
    try {
        const experiments = overrides.filter((overrides)=>overrides.type === 'experiment');
        const customGetFrontendExperiment = ({ abTestId: abTestId, onError: onError })=>{
            const overrideFrontendExperiment = experiments.find((override)=>'name' in override && override.name === abTestId);
            if (!overrideFrontendExperiment) return $3a954310db248169$export$a68238496eb1c8ce({
                abTestId: abTestId,
                onError: onError
            });
            return {
                abTestId: abTestId,
                serveExperiment: true,
                cohort: 'cohort' in overrideFrontendExperiment ? overrideFrontendExperiment.cohort : (0, $4vEoF.Cohort).Test
            };
        };
        return customGetFrontendExperiment;
    } catch (e) {
        console.error(e);
        return $3a954310db248169$export$a68238496eb1c8ce;
    }
};
// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
const $3a954310db248169$var$defaultCheckGate = (name)=>(0, $c6GJD.default).checkGate(name);
const $3a954310db248169$export$b8cc3cdd046fba93 = (uiExperimentName, layerName, options = {
    fireLayerExposure: true
})=>{
    const layer = (0, $c6GJD.default).getLayer(layerName, {
        fireLayerExposure: false
    });
    const frontendExperimentName = layer.get('frontendExperimentName', '');
    if (frontendExperimentName === uiExperimentName) return (0, $c6GJD.default).getLayer(layerName, options);
    return undefined;
};
module.exports["getFrontendExperiment"] = $3a954310db248169$export$a68238496eb1c8ce;
module.exports["createFeatureGateHandler"] = $3a954310db248169$export$8774a01dc80b4a26;
module.exports["createFrontendExperimentHandler"] = $3a954310db248169$export$841981a8a1feee8d;
module.exports["getMutuallyExclusiveUIExperiment"] = $3a954310db248169$export$b8cc3cdd046fba93;

});

parcelRegister("4vEoF", function(module, exports) {
var $f534e05ac776c43b$export$b76685d1b5a37732 = /*#__PURE__*/ function(Cohort) {
    Cohort["Default"] = "not-enrolled";
    Cohort["Control"] = "control";
    Cohort["Test"] = "test";
    return Cohort;
}({});
module.exports["Cohort"] = $f534e05ac776c43b$export$b76685d1b5a37732;

});

parcelRegister("2NVuz", function(module, exports) {
/** Types copied from platform/packages/ai-mate/conversation-assistant/src/services/assistance-service/types.ts for now */ var $605e1a783968ada3$export$49d1ac864ca8db3a = /*#__PURE__*/ function(NLPSearchDisclaimerType) {
    NLPSearchDisclaimerType["WhoDisclaimer"] = "WHO_QUESTION";
    return NLPSearchDisclaimerType;
}({});
var $605e1a783968ada3$export$255ec938a30a2b3 = /*#__PURE__*/ function(StreamAnswerGenerationTypes) {
    StreamAnswerGenerationTypes["LUMINA"] = "LUMINA";
    StreamAnswerGenerationTypes["STANDARD"] = "STANDARD";
    return StreamAnswerGenerationTypes;
}({});
const $605e1a783968ada3$export$b4631726cbc1440a = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $605e1a783968ada3$export$d422a2733a3b5def = (message)=>message instanceof Object && message.type === 'ERROR';
const $605e1a783968ada3$export$e45102edbc73b240 = (message)=>message instanceof Object && message.type === 'ANSWER_PART';
const $605e1a783968ada3$export$c563bc6129a38894 = (message)=>message instanceof Object && message.type === 'ANSWER_GENERATION_TYPE';
const $605e1a783968ada3$export$fd5a05be03f147a0 = (message)=>message instanceof Object && message.type === 'TRACE';
const $605e1a783968ada3$export$51a1b4e474708d74 = (message)=>message instanceof Object && message.type === 'PLUGIN_INVOCATION';
const $605e1a783968ada3$export$cfb6b6bb809f778e = (message)=>message instanceof Object && message.type === 'FOLLOW_UP_QUERIES';
const $605e1a783968ada3$export$de29cc71fd2aafc1 = (message)=>message instanceof Object && message.type === 'ERROR_STATE_QUERY_SUGGESTIONS';
const $605e1a783968ada3$export$5fa02529cd2ab34c = (message)=>message instanceof Object && message.type === 'DL_SUB_AGENT';
const $605e1a783968ada3$export$b6b59db8d0b45219 = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $605e1a783968ada3$export$1598409b78d1d369 = (message)=>message instanceof Object && message.type === 'EARLY_STOP';
const $605e1a783968ada3$export$53e95dec5f877b4e = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
module.exports["StreamAnswerGenerationTypes"] = $605e1a783968ada3$export$255ec938a30a2b3;
module.exports["isStreamResponse"] = $605e1a783968ada3$export$b4631726cbc1440a;
module.exports["isStreamError"] = $605e1a783968ada3$export$d422a2733a3b5def;
module.exports["isStreamAnswerPart"] = $605e1a783968ada3$export$e45102edbc73b240;
module.exports["isStreamGenerationType"] = $605e1a783968ada3$export$c563bc6129a38894;
module.exports["isStreamTrace"] = $605e1a783968ada3$export$fd5a05be03f147a0;
module.exports["isStreamFollowUp"] = $605e1a783968ada3$export$cfb6b6bb809f778e;
module.exports["isStreamErrorStateQuerySuggestions"] = $605e1a783968ada3$export$de29cc71fd2aafc1;
module.exports["isStreamDynamicLayoutSubAgent"] = $605e1a783968ada3$export$5fa02529cd2ab34c;
module.exports["isStreamSAINResponse"] = $605e1a783968ada3$export$b6b59db8d0b45219;
module.exports["isStreamEarlyStop"] = $605e1a783968ada3$export$1598409b78d1d369;
module.exports["isStreamDefinitionResponse"] = $605e1a783968ada3$export$53e95dec5f877b4e;

});

parcelRegister("5Wlau", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $7Zbm6 = parcelRequire("7Zbm6");


var $4Zqgi = parcelRequire("4Zqgi");


var $2NVuz = parcelRequire("2NVuz");

const $087142bc218bc052$var$mapMimeTypeToFormat = (mimeType)=>{
    switch(mimeType){
        case 'text/markdown':
            return (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN;
        case 'text/adf':
            return (0, $7Zbm6.NLPSearchResultFormat).ADF;
        case 'text/json':
            return (0, $7Zbm6.NLPSearchResultFormat).JSON;
        default:
            return (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN;
    }
};
const $087142bc218bc052$var$mapErrorTo = (error, traceId)=>{
    const errorMessage = 'message_template' in error ? error.message_template : error.message.message_template;
    switch(errorMessage){
        case 'NO_ANSWER_LLM':
            return (0, $7Zbm6.NLPSearchErrorState).NoAnswer;
        case 'NO_ANSWER_PEOPLE':
            return (0, $7Zbm6.NLPSearchErrorState).NoAnswerWhoQuestion;
        case 'NO_ANSWER_KEYWORDS':
            return (0, $7Zbm6.NLPSearchErrorState).NoAnswerKeywords;
        case 'NO_ANSWER_SEARCH_QA_PLUGIN':
            return (0, $7Zbm6.NLPSearchErrorState).NoAnswerSearchResults;
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return (0, $7Zbm6.NLPSearchErrorState).AcceptableUseViolation;
        case 'OPENAI_RATE_LIMIT_USER_ABUSE':
            return (0, $7Zbm6.NLPSearchErrorState).NoAnswerOpenAIRateLimitUserAbuse;
        case 'FEATURE_DISABLED_ON_SITE':
            return (0, $7Zbm6.NLPSearchErrorState).AIDisabled;
        default:
            (0, $4Zqgi.logger).error({
                error: error,
                functionName: 'mapErrorToSain: NetworkError',
                traceId: traceId
            });
            return (0, $7Zbm6.NLPSearchErrorState).NetworkError;
    }
};
const $087142bc218bc052$var$identityUserCloudARIPrefix = 'ari:cloud:identity::user/';
const $087142bc218bc052$export$b4465cb8e5734ca9 = (message, requestId)=>{
    // Handle cases where message is directly in root or nested under message.message
    const messageContent = message.message;
    return {
        nlpResult: messageContent.content,
        uniqueSources: message.sources ? message.sources.map((source)=>({
                ari: source.ari,
                id: source.id?.toString(),
                title: source.title,
                product: source.product,
                type: source.type,
                url: source.url,
                lastModified: source.lastModified,
                iconUrl: null,
                spaceName: null,
                spaceUrl: null
            })) : [],
        disclaimer: messageContent.message_metadata?.disclaimer ?? null,
        errorState: null,
        format: $087142bc218bc052$var$mapMimeTypeToFormat(messageContent.content_mime_type),
        extraAPIAnalyticsAttributes: {
            message_id: messageContent.id,
            conversational_channel_id: messageContent.conversation_channel_id,
            experience_id: messageContent.experience_id,
            user_id: messageContent.user_ari?.replace($087142bc218bc052$var$identityUserCloudARIPrefix, '') ?? null,
            userQuery: message.human_message?.content ?? null,
            requestId: (0, $dh538.fg)('kd_fix_sain_mau_instrumentation') ? requestId ?? null : messageContent.message_metadata?.request_id ?? null,
            answerGenerationModel: message.usage_data ?? null,
            sources: message.sources,
            cacheInfo: messageContent.message_metadata?.global_cache_info ?? null,
            pluginInvocations: messageContent.plugin_invocations,
            rawJson: message,
            ...(0, $dh538.fg)('kd_sain_online_debugger') && {
                minion_outputs: message.message?.minion_outputs,
                traceId: requestId ?? null
            }
        }
    };
};
const $087142bc218bc052$export$ed070f749797478 = (response, traceId)=>{
    if ((0, $2NVuz.isStreamError)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse,
        message: {
            errorState: $087142bc218bc052$var$mapErrorTo(response, traceId),
            errorCode: response.message.status_code,
            disclaimer: null,
            format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN,
            uniqueSources: []
        }
    };
    if ((0, $2NVuz.isStreamGenerationType)(response) && (0, $dh538.fg)('kd_dynamic_layout_in_sain')) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).GenerationType,
        message: {
            answer_generation_type: response.message.answer_generation_type
        }
    };
    if ((0, $2NVuz.isStreamTrace)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).Trace,
        message: response.message.content
    };
    if ((0, $2NVuz.isStreamAnswerPart)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).AnswerPart,
        message: {
            nlpResult: response.message.content
        }
    };
    if ((0, $2NVuz.isStreamSAINResponse)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse,
        message: $087142bc218bc052$export$b4465cb8e5734ca9(response.message, traceId)
    };
    if ((0, $2NVuz.isStreamFollowUp)(response)) return {
        type: 'follow-up',
        queries: response.message.follow_up_queries ?? []
    };
    if ((0, $2NVuz.isStreamErrorStateQuerySuggestions)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).ErrorStateQuerySuggestions,
        suggested_queries: response.message.suggested_queries ?? []
    };
    if ((0, $dh538.fg)('kd_dynamic_layout_in_sain')) {
        if ((0, $2NVuz.isStreamDynamicLayoutSubAgent)(response)) return {
            type: (0, $7Zbm6.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage,
            message: response.message
        };
    }
    if ((0, $dh538.fg)('kd_sain_early_stop_hello_exp_fg') || (0, $dh538.fg)('kd_sain_early_stop_customer_exp_fg')) {
        if ((0, $2NVuz.isStreamEarlyStop)(response)) {
            const earlyStopSearchResult = {
                nlpResult: response.message?.reason ?? '',
                format: null,
                uniqueSources: [],
                errorState: (0, $7Zbm6.NLPSearchErrorState).EarlyStop,
                disclaimer: null
            };
            return {
                type: (0, $7Zbm6.AIAnswerQueryStreamType).EarlyStop,
                message: earlyStopSearchResult
            };
        }
    }
    return {
        // Don't currently handle other types, such as PLUGIN_INVOCATION
        type: 'other'
    };
};
const $087142bc218bc052$export$b4d3daa122c7e257 = (message)=>{
    return {
        nlpResult: message.content,
        uniqueSources: message.sources ? message.sources.map((source)=>({
                ari: source.ari,
                id: source.id?.toString(),
                title: source.title,
                product: source.product,
                type: source.type,
                url: source.url,
                lastModified: source.lastModified,
                iconUrl: null,
                spaceName: null,
                spaceUrl: null
            })) : [],
        disclaimer: null,
        errorState: null,
        format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN,
        extraAPIAnalyticsAttributes: {
            userQuery: message.human_message?.content ?? null,
            answerGenerationModel: message.usage_data ?? null,
            sources: message.sources,
            rawJson: message
        }
    };
};
const $087142bc218bc052$export$fb9e9bea38ae660f = (response, traceId)=>{
    if ((0, $2NVuz.isStreamError)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse,
        message: {
            errorState: $087142bc218bc052$var$mapErrorTo(response, traceId),
            errorCode: response.message.status_code,
            disclaimer: null,
            format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN,
            uniqueSources: []
        }
    };
    if ((0, $2NVuz.isStreamTrace)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).Trace,
        message: response.message.content
    };
    if ((0, $2NVuz.isStreamAnswerPart)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).AnswerPart,
        message: {
            nlpResult: response.message.content
        }
    };
    if ((0, $2NVuz.isStreamDefinitionResponse)(response)) return {
        type: (0, $7Zbm6.AIAnswerQueryStreamType).FinalResponse,
        message: $087142bc218bc052$export$b4d3daa122c7e257(response.message)
    };
    if ((0, $2NVuz.isStreamFollowUp)(response)) return {
        type: 'follow-up',
        queries: response.message.follow_up_queries ?? []
    };
    return {
        // Don't currently handle other types, such as PLUGIN_INVOCATION
        type: 'other'
    };
};
module.exports["mapStreamSAINResponse"] = $087142bc218bc052$export$ed070f749797478;
module.exports["mapStreamDefinitionResponse"] = $087142bc218bc052$export$fb9e9bea38ae660f;

});

parcelRegister("xhg8G", function(module, exports) {

var $cqFuK = parcelRequire("cqFuK");

const $d691b863678f8843$export$1b6ec2a437dbf65e = (error, commonAttributes)=>{
    const { extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'failed',
        actionSubject: 'aiCuratedDefinitionFetch',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.sanitizeExtraAttributes)(extraAttributes),
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    };
};
const $d691b863678f8843$export$b3c6d7a1ecb4efe1 = (error, commonAttributes)=>{
    const { extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'failed',
        actionSubject: 'aiPrecomputedDefinitionFetch',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.sanitizeExtraAttributes)(extraAttributes),
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    };
};
const $d691b863678f8843$export$ef8b7cdd9a33efb4 = (error, commonAttributes)=>{
    const { extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'failed',
        actionSubject: 'aiCuratedDefinitionUpdate',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.sanitizeExtraAttributes)(extraAttributes),
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    };
};
const $d691b863678f8843$export$48200d71a3e25afe = (error, commonAttributes)=>{
    const { extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'failed',
        actionSubject: 'aiDefinitionToggle',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $cqFuK.sanitizeExtraAttributes)(extraAttributes),
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    };
};
module.exports["fetchCuratedDefinitionErrorPayload"] = $d691b863678f8843$export$1b6ec2a437dbf65e;
module.exports["fetchPrecomputedDefinitionErrorPayload"] = $d691b863678f8843$export$b3c6d7a1ecb4efe1;
module.exports["updateDefinitionErrorPayload"] = $d691b863678f8843$export$ef8b7cdd9a33efb4;
module.exports["toggleDefinitionErrorPayload"] = $d691b863678f8843$export$48200d71a3e25afe;

});

parcelRegister("9nZle", function(module, exports) {
// query to check whether curated definition exists
const $797cf255205c2458$export$9051e5c888508a3d = 'CuratedDefinitionQuery';
const $797cf255205c2458$export$1886f34f107a0451 = `
query ${$797cf255205c2458$export$9051e5c888508a3d}(
		$workspaceId: String!
		$keyPhrase: String!
		$confluenceScopeId: KnowledgeDiscoveryDefinitionScopeIdConfluence
		$jiraScopeId: KnowledgeDiscoveryDefinitionScopeIdJira
	) {
		knowledgeDiscovery {
			definition(
				workspaceId: $workspaceId
				keyPhrase: $keyPhrase
				confluenceScopeId: $confluenceScopeId
				jiraScopeId: $jiraScopeId
			) @optIn(to: "KnowledgeDiscovery Get definition") {
				__typename
				... on KnowledgeDiscoveryDefinition {
					definition
					accountId
					createdAt
					editor {
						... on User {
							name
							accountId
						}
					}
					referenceUrl
					confluenceEntity {
						... on ConfluencePage {
							id
							type
							title
							space {
								name
							}
						}
						... on ConfluenceBlogPost {
							id
							type
							title
							space {
								name
							}
						}
					}
				}
				... on QueryError {
					message
				}
			}
		}
	}
`;
module.exports["CURATED_DEFINITION_OPERATION_NAME"] = $797cf255205c2458$export$9051e5c888508a3d;
module.exports["CuratedDefinitionQuery"] = $797cf255205c2458$export$1886f34f107a0451;

});

parcelRegister("4WiNS", function(module, exports) {
const $205ce4d60dc88166$export$73cd67d787c37f2e = `
query PrecomputedDefinitionQuery(
		$workspaceId: String!
		$keyPhrase: String!
        $contentId: String!
	) {
		knowledgeDiscovery {
			autoDefinition(
				workspaceId: $workspaceId
				keyPhrase: $keyPhrase
				contentId: $contentId
			) @optIn(to: "KnowledgeDiscovery Get auto definition") {
				__typename
				... on KnowledgeDiscoveryAutoDefinition {
					definition
                    createdAt
					confluenceEntity {
						... on ConfluencePage {
							id
							type
							title
							space {
								name
							}
                            links {
                                base
                                webUi
                            }
						}
						... on ConfluenceBlogPost {
							id
							type
							title
							space {
								name
							}
                            links {
                                base
                                webUi
                            }
						}
					}
				}
				... on QueryError {
					message
                    extensions {
                        statusCode
                        errorType
                    }
				}
			}
		}
	}
`;
module.exports["PrecomputedDefinitionQuery"] = $205ce4d60dc88166$export$73cd67d787c37f2e;

});

parcelRegister("3qbRZ", function(module, exports) {

var $7Zbm6 = parcelRequire("7Zbm6");

const $9a638390fddaeddf$export$faaccabd846a199 = (definition)=>{
    const definitionReference = definition.confluenceEntity;
    return {
        nlpResult: definition.definition,
        uniqueSources: definitionReference ? [
            {
                id: definitionReference?.id || '',
                title: definitionReference?.title || '',
                url: 'referenceUrl' in definition ? definition.referenceUrl || '' : 'links' in definitionReference && definitionReference.links.base && definitionReference.links.webUi ? `${definitionReference.links.base}${definitionReference.links.webUi}` : '',
                type: definitionReference?.type || '',
                // Currently curated and precomputed definitions sources can only be Confluence
                product: 'Confluence',
                lastModified: '',
                iconUrl: '',
                spaceName: definitionReference?.space?.name || '',
                spaceUrl: null
            }
        ] : [],
        nlpResultEditor: 'editor' in definition ? {
            name: definition.editor?.name || '',
            id: definition.editor?.accountId || ''
        } : undefined,
        disclaimer: null,
        errorState: null,
        format: (0, $7Zbm6.NLPSearchResultFormat).MARKDOWN,
        customDefinitionType: 'editor' in definition ? (0, $7Zbm6.NLPSearchCustomDefinitionType).CURATED : (0, $7Zbm6.NLPSearchCustomDefinitionType).PRECOMPUTED
    };
};
module.exports["mapCustomDefinitionToNLPSearchType"] = $9a638390fddaeddf$export$faaccabd846a199;

});

parcelRegister("7DCm4", function(module, exports) {

var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");

const $399439794f928dc1$var$DEFINITIONS_COMPONENT = 'search-ai-definitions';
const $399439794f928dc1$export$5b2a28beea8d66c3 = new (0, $5aVN7.UFOExperience)(`${$399439794f928dc1$var$DEFINITIONS_COMPONENT}-load`, {
    type: (0, $9NDUe.ExperienceTypes).Experience,
    performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: $399439794f928dc1$var$DEFINITIONS_COMPONENT
    }
});
module.exports["aiDefinitionsLoadUFOExperience"] = $399439794f928dc1$export$5b2a28beea8d66c3;

});

parcelRegister("jWDKZ", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $4dd7b9fe81a55e61$export$ab78b8e7dad428f8 = ({ singleClickCallback: singleClickCallback, doubleClickCallback: doubleClickCallback, delay: delay = 250 })=>{
    const [state, setState] = (0, $42omo.useState)({
        e: null
    });
    (0, $42omo.useEffect)(()=>{
        if (!Boolean(state.e)) return;
        const timer = setTimeout(()=>{
            // single click
            if (state.e?.detail === 1) singleClickCallback(state.e);
            else if (state.e?.detail && state.e.detail > 1) doubleClickCallback(state.e);
            setState({
                e: null
            });
        }, delay);
        return ()=>clearTimeout(timer);
    }, [
        state,
        singleClickCallback,
        doubleClickCallback,
        delay
    ]);
    return (e)=>{
        setState({
            e: e
        });
    };
};
const $4dd7b9fe81a55e61$export$f93f1774a43b3eae = ({ singleClickCallback: singleClickCallback, doubleClickCallback: doubleClickCallback, delay: delay = 250 })=>{
    const [state, setState] = (0, $42omo.useState)({
        click: 0,
        e: null
    });
    (0, $42omo.useEffect)(()=>{
        if (!Boolean(state.e)) return;
        const timer = setTimeout(()=>{
            // simple click
            if (state.click === 1) singleClickCallback(state.e);
            setState({
                e: null,
                click: 0
            });
        }, delay);
        // the duration between this click and the previous one
        // is less than the value of delay = double-click
        if (state.click === 2) doubleClickCallback(state.e);
        return ()=>clearTimeout(timer);
    }, [
        state,
        singleClickCallback,
        doubleClickCallback,
        delay
    ]);
    return (e)=>{
        setState({
            click: state.click + 1,
            e: e
        });
    };
};
module.exports["useTextHighlighterClickNative"] = $4dd7b9fe81a55e61$export$ab78b8e7dad428f8;
module.exports["useTextHighlighterClick"] = $4dd7b9fe81a55e61$export$f93f1774a43b3eae;

});

parcelRegister("7wVkn", function(module, exports) {
/* definition-popup.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $lGgRw = parcelRequire("lGgRw");

const $7a4b02046260f338$var$popupContainerStyles = null;
const $7a4b02046260f338$var$CustomPopupContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, ...props }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ...props,
        ref: ref,
        className: (0, $gMc0m.default)([
            "_1pbyowjs"
        ]),
        children: children
    });
});
const $7a4b02046260f338$var$definitionPopupTriggerStylesStatic = null;

const $7a4b02046260f338$var$LazyDefinitionPopupContent = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("3e1B0")).then((module)=>({
            default: module.DefinitionPopupContent
        })));
function $7a4b02046260f338$export$576a6d4c65a0c923({ onClose: onClose, triggerPosition: triggerPosition, onLoad: onLoad, ...definitionPopupContentProps }) {
    const definitionPopupTriggerStylesDynamic = {
        height: `${triggerPosition.height}px`,
        left: `${triggerPosition.left}px`,
        top: `${triggerPosition.top}px`,
        width: `${triggerPosition.width}px`
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
        content: ({ update: update })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $l998X.jsx)($7a4b02046260f338$var$LazyDefinitionPopupContent, {
                    ...definitionPopupContentProps,
                    onClose: onClose,
                    onLoad: ()=>{
                        onLoad?.();
                        update();
                    }
                })
            }),
        onClose: onClose,
        placement: "bottom-start",
        popupComponent: $7a4b02046260f338$var$CustomPopupContainer,
        testId: "definition-popup",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)("span", {
                ...triggerProps,
                style: definitionPopupTriggerStylesDynamic,
                "data-testid": "definition-popup-trigger",
                className: (0, $gMc0m.default)([
                    "_tzy4idpf _kqswstnw _lcxvglyw _bfhk1j28 _1ltvidpf _94n5idpf"
                ])
            }),
        isOpen: true
    });
}
module.exports["DefinitionPopup"] = $7a4b02046260f338$export$576a6d4c65a0c923;

});

parcelRegister("3e1B0", function(module, exports) {

let $2593eacf9562c8c0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2593eacf9562c8c0$var$load("d6s42"),
    $2593eacf9562c8c0$var$load("2YffH"),
    $2593eacf9562c8c0$var$load("iDB1L"),
    $2593eacf9562c8c0$var$load("19uFC"),
    $2593eacf9562c8c0$var$load("a4yJG"),
    $2593eacf9562c8c0$var$load("6mHrv"),
    $2593eacf9562c8c0$var$load("2Gceu"),
    $2593eacf9562c8c0$var$load("1FvvC"),
    $2593eacf9562c8c0$var$load("9zkjw"),
    $2593eacf9562c8c0$var$load("d2Wke"),
    $2593eacf9562c8c0$var$load("1QdXB"),
    $2593eacf9562c8c0$var$load("eEyVs"),
    $2593eacf9562c8c0$var$load("eieu4"),
    $2593eacf9562c8c0$var$load("1YtXy"),
    $2593eacf9562c8c0$var$load("hyzoX"),
    $2593eacf9562c8c0$var$load("h9Ed7"),
    $2593eacf9562c8c0$var$load("aRBi5"),
    $2593eacf9562c8c0$var$load("eiooB"),
    $2593eacf9562c8c0$var$load("iLyOq"),
    $2593eacf9562c8c0$var$load("ikQAz"),
    $2593eacf9562c8c0$var$load("31bKg"),
    $2593eacf9562c8c0$var$load("8VzWv"),
    $2593eacf9562c8c0$var$load("8YSo7"),
    $2593eacf9562c8c0$var$load("gryT8"),
    $2593eacf9562c8c0$var$load("5uN9h"),
    $2593eacf9562c8c0$var$load("9XYQ9"),
    $2593eacf9562c8c0$var$load("kiGNy"),
    $2593eacf9562c8c0$var$load("cHQ50"),
    $2593eacf9562c8c0$var$load("k8XPW"),
    $2593eacf9562c8c0$var$load("fWCRm"),
    $2593eacf9562c8c0$var$load("8MntV"),
    $2593eacf9562c8c0$var$load("g9CVe"),
    $2593eacf9562c8c0$var$load("jTaSF"),
    $2593eacf9562c8c0$var$load("amdBm"),
    $2593eacf9562c8c0$var$load("8fXIr"),
    $2593eacf9562c8c0$var$load("dVkhd"),
    $2593eacf9562c8c0$var$load("7jSfd"),
    $2593eacf9562c8c0$var$load("4HZlX"),
    $2593eacf9562c8c0$var$load("kDqHr"),
    $2593eacf9562c8c0$var$load("6wr18"),
    $2593eacf9562c8c0$var$load("kjZZD"),
    $2593eacf9562c8c0$var$load("ht5OT"),
    $2593eacf9562c8c0$var$load("sj9Xz"),
    $2593eacf9562c8c0$var$load("Wowvf"),
    $2593eacf9562c8c0$var$load("dTsOE"),
    $2593eacf9562c8c0$var$load("hhss7"),
    $2593eacf9562c8c0$var$load("6kZfp"),
    $2593eacf9562c8c0$var$load("2UbDA"),
    $2593eacf9562c8c0$var$load("ffEVr"),
    $2593eacf9562c8c0$var$load("jSdjl"),
    $2593eacf9562c8c0$var$load("l2EUC"),
    $2593eacf9562c8c0$var$load("gZGoR"),
    $2593eacf9562c8c0$var$load("joFPh"),
    $2593eacf9562c8c0$var$load("7EorR"),
    $2593eacf9562c8c0$var$load("77ceh")
]).then(()=>parcelRequire('bA47i'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("9KkVf", function(module, exports) {
var $3b7655b6bdb7bdb0$export$a53c998f5fa685e1 = /*#__PURE__*/ function(EditedDefinitionScope) {
    EditedDefinitionScope["SPACE"] = "SPACE";
    EditedDefinitionScope["PAGE"] = "PAGE";
    EditedDefinitionScope["BLOGPOST"] = "BLOGPOST";
    EditedDefinitionScope["ORGANIZATION"] = "ORGANIZATION";
    EditedDefinitionScope["PROJECT"] = "PROJECT";
    return EditedDefinitionScope;
}({});
module.exports["EditedDefinitionScope"] = $3b7655b6bdb7bdb0$export$a53c998f5fa685e1;

});

parcelRegister("97Szk", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $chO1Z = parcelRequire("chO1Z");


var $gXn1S = parcelRequire("gXn1S");


var $ctmPb = parcelRequire("ctmPb");


var $9RVmI = parcelRequire("9RVmI");


var $9KkVf = parcelRequire("9KkVf");

const $3fda69966c9a64cd$var$i18n = (0, $cgtv4.defineMessages)({
    editDefinitionRestrictedToSpaceOption: {
        id: "contextual-reading-aids.edit.definition.restricted.to.space.option",
        defaultMessage: "In this space"
    },
    editDefinitionRestrictedToPageOption: {
        id: "contextual-reading-aids.edit.definition.restricted.to.page.option",
        defaultMessage: "On this page"
    },
    editDefinitionRestrictedToBlogpostOption: {
        id: "contextual-reading-aids.edit.definition.restricted.to.blogpost.option",
        defaultMessage: "On this blogpost"
    },
    editDefinitionRestrictedToSiteOption: {
        id: "contextual-reading-aids.edit.definition.restricted.to.site.option",
        defaultMessage: "On this site"
    }
});
function $3fda69966c9a64cd$export$ad09b24d617a41f5(contentType) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return (0, $42omo.useMemo)(()=>[
            {
                label: formatMessage($3fda69966c9a64cd$var$i18n.editDefinitionRestrictedToSpaceOption),
                value: (0, $9KkVf.EditedDefinitionScope).SPACE,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gXn1S))), {
                    label: ""
                })
            },
            contentType === 'blogpost' ? {
                label: formatMessage($3fda69966c9a64cd$var$i18n.editDefinitionRestrictedToBlogpostOption),
                value: (0, $9KkVf.EditedDefinitionScope).BLOGPOST,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))), {
                    label: ""
                })
            } : {
                label: formatMessage($3fda69966c9a64cd$var$i18n.editDefinitionRestrictedToPageOption),
                value: (0, $9KkVf.EditedDefinitionScope).PAGE,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chO1Z))), {
                    label: ""
                })
            },
            {
                label: formatMessage($3fda69966c9a64cd$var$i18n.editDefinitionRestrictedToSiteOption),
                value: (0, $9KkVf.EditedDefinitionScope).ORGANIZATION,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ctmPb))), {
                    label: ""
                })
            }
        ], [
        contentType,
        formatMessage
    ]);
}
module.exports["useDefinitionRestrictionOptions"] = $3fda69966c9a64cd$export$ad09b24d617a41f5;

});


//# sourceMappingURL=CommentsPanelFilterMenu.09f0bfa4.js.map
